import {FC, useEffect, useState} from 'react'
import {useFormContext} from 'react-hook-form'
import {SelectWrapper, InputTextWrapper} from '../../../../../../components/UI/Form/Input'
import HeaderTitle from '../../../componentes/Form/Header'
import {getSupplier, getLaundryConfigHoursById} from '../../../../services'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {TabLavanderiaModel} from '../../../../../../models'
import {SelectModel, SupplierModel} from '../../../../model'
import {TITLE_FORM_CONFIG_HOURS} from '../../../../util/Constants'
import useSiteListService from '../../../../../central/hooks/useSiteService'
import {useTableMaster} from '../../../../hooks'
const LaundryConfigHours: FC = () => {
  const {setError, setValue, watch, reset} = useFormContext()
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const [supplier, setSupplier] = useState<SelectModel[]>([])
  const {typeConfig, getTypeConfigList} = useTableMaster()
  const {siteList, getSiteList} = useSiteListService()

  const getSupplierList = async () => {
    let obj: SupplierModel = {
      isCombo: true,
    }
    const response = await getSupplier(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({
      value: item.id,
      label: item.razonSocial,
    }))
    setSupplier(mappedSites)
  }

  const getEquipmentByIdValues = async () => {
    const response = await getLaundryConfigHoursById(currentTabItem.idToEdit)
    const data = response.data.data
    setValue('TipoConfiguracion', data.TipoConfiguracion)
    setValue('ProveedorId', data.ProveedorId || '')
    setValue('SiteId', data.SiteId || '')
    setValue('Valor', data.Valor)
  }

  useEffect(() => {
    getSiteList()
    getSupplierList()
    getTypeConfigList()
  }, [])

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getEquipmentByIdValues()
    }
  }, [currentTabItem.idToEdit])

  const handleBack = () => {
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
    }
    reset()
    changeCurrentTabItem(obj)
  }

  const handleChangeTypeConfig = (e: any) => {
    let value = e.value
    setValue('TipoConfiguracion', value)
    setError('TipoConfiguracion', {})
    setValue('Valor', '')
    if (value === 'CTLPROVEEDOR') {
      setValue('SiteId', '')
    }
    if (value === 'CTLSITE') {
      setValue('ProveedorId', '')
    }
  }

  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <div className='sdx_form card p-4'>
      <HeaderTitle isEdit={isDisabled} title={TITLE_FORM_CONFIG_HOURS} handleBack={handleBack} />
      <div className='row'>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Tipo de Configuración'
            name='TipoConfiguracion'
            data={typeConfig}
            disabled={isDisabled}
            onChangeValue={handleChangeTypeConfig}
            required
          />
        </div>
        {watch('TipoConfiguracion') === 'CTLPROVEEDOR' && (
          <div className='col-sm-12 col-lg-3'>
            <SelectWrapper labelText='Proveedor' name='ProveedorId' data={supplier} required />
          </div>
        )}
        {watch('TipoConfiguracion') === 'CTLSITE' && (
          <div className='col-sm-12 col-lg-3'>
            <SelectWrapper
              labelText='Site'
              name='SiteId'
              data={siteList}
              disabled={isDisabled}
              required
            />
          </div>
        )}
        {watch('TipoConfiguracion') && (
          <div className='col-sm-12 col-lg-3'>
            <InputTextWrapper
              labelText='Valor en dias'
              name='Valor'
              textPlaceholder='Escribe el valor en dias'
              //   disabled={isDisabled}
              type='numeric'
              required
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default LaundryConfigHours
